import { Box, Paper, Typography } from "@mui/material";
import React from "react";

interface Props {
  title: string | React.ReactElement
  children: React.ReactElement
}

const Section: React.FC<Props> = ({ title, children }: Props) => {
  return (
    <Box component={Paper} sx={styles.sectionContainer}>
      <Typography variant="h2">{ title }</Typography>
      <Box className="section-body">
        { children }
      </Box>
    </Box>
  )
}
export default Section;

const styles = {
  sectionContainer: {
    marginTop: 2,
    "& h2": {
      padding: 2,
      fontSize: "0.875rem",
      fontWeight: 500
    },
    "& .section-body": {
      padding: 2,
      borderTop: "1px solid #DCDCDC",
    }
  }
}